import { Component, OnInit,Input } from '@angular/core';
import { CommonPipe } from '@pipes/common.pipe';

@Component({
  selector: 'app-btimeline',
  templateUrl: './btimeline.component.html',
  styleUrls: ['./btimeline.component.sass']
})
export class BtimelineComponent implements OnInit {
  @Input('a') application: string;
  @Input('c') component: string;
  @Input('appname') name: string;
  @Input('appid') id: string;
  @Input('res')  res:object;
  constructor(private _commonPipe: CommonPipe) {
    
   }

  ngOnInit(): void {

  }
  gotoView(){
    
   // [res|common:['appviewurl',application,component,'name,category']]
  }

}
